import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ICONES, type IconeNome } from './icones';

export type IconeTamanho = 'xs' | 'sm' | 'md' | 'lg';

// Strings completas para o Tailwind gerar as classes.
const CLASSES_TAMANHO: Record<IconeTamanho, string> = {
  xs: 'text-[0.75rem]',
  sm: 'text-[0.875rem]',
  md: 'text-[1.125rem]',
  lg: 'text-[1.5rem]',
};

/**
 * Ícone do registro `ICONES` (FontAwesome). Decorativo por padrão (`aria-hidden`); passe
 * `rotulo` quando o ícone for a única informação (vira `role="img"`).
 */
@Component({
  selector: 'app-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'classes()',
    '[attr.role]': 'rotulo() ? "img" : null',
    '[attr.aria-label]': 'rotulo() || null',
    '[attr.aria-hidden]': 'rotulo() ? null : "true"',
  },
  template: `<i [class]="icone()" aria-hidden="true"></i>`,
})
export class IconComponent {
  readonly nome = input.required<IconeNome>();
  readonly tamanho = input<IconeTamanho>('md');
  readonly rotulo = input<string>();

  protected readonly icone = computed(() => ICONES[this.nome()]);
  protected readonly classes = computed(
    () => `inline-flex shrink-0 items-center justify-center size-[1em] leading-none ${CLASSES_TAMANHO[this.tamanho()]}`,
  );
}
